import "./postsColunistas.css";
import { useEffect, useState } from "react";
import api from "../../constants/api.js";
import Modal from "../../components/modal/modal.jsx";
import { useNavigate, useParams } from "react-router-dom";
import BtnVoltar from "../../components/btn-voltar/btn-voltar.jsx";
import Swal from "sweetalert2";

function PostsColunistas() {
  const [postsColunistas, setPostsColunistas] = useState([]);
  const [open, setOpen] = useState(false);
  const [editandoId, setEditandoId] = useState(null);
  const [titulo, setTitulo] = useState("");
  const [texto, setTexto] = useState("");
  const [img, setImg] = useState(null);

  const { id_colunista } = useParams();
  const navigate = useNavigate();

  /* =========================
     BUSCAR POSTS DO COLUNISTA (ADMIN)
  ========================= */
  useEffect(() => {
    async function fetchPostsColunistas() {
      try {
        const response = await api.get(
          `/admin/colunistas/${id_colunista}/posts`
        );
        setPostsColunistas(response.data || []);
      } catch (error) {
        console.log(
          error.response?.data?.error ||
            "Erro ao buscar posts do colunista"
        );
      }
    }

    fetchPostsColunistas();
  }, [id_colunista]);

  /* =========================
     MODAL
  ========================= */
  function abrirModal() {
    setTitulo("");
    setTexto("");
    setImg(null);
    setEditandoId(null);
    setOpen(true);
  }

  function editarPost(post) {
    setEditandoId(post.id_post_colunista);
    setTitulo(post.titulo);
    setTexto(post.texto);
    setImg(post.foto);
    setOpen(true);
  }

  function voltar() {
    navigate("/colunistas");
  }

  /* =========================
     INSERIR POST (ADMIN)
  ========================= */
  async function enviarPost() {
    if (!titulo.trim()) throw new Error("Título é obrigatório");
    if (!texto.trim()) throw new Error("Texto é obrigatório");

    const formData = new FormData();
    formData.append("titulo", titulo);
    formData.append("texto", texto);
    if (img) formData.append("foto", img);

    const response = await api.post(
      `/admin/colunistas/${id_colunista}/posts`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    setPostsColunistas(prev => [response.data, ...prev]);
    setOpen(false);
  }

  /* =========================
     EDITAR POST (ADMIN)
  ========================= */
  async function enviarEdit() {
    if (!titulo.trim()) throw new Error("Título é obrigatório");
    if (!texto.trim()) throw new Error("Texto é obrigatório");

    const formData = new FormData();
    formData.append("titulo", titulo);
    formData.append("texto", texto);
    if (img && typeof img !== "string") {
      formData.append("foto", img);
    }

    const response = await api.put(
      `/admin/colunistas/${id_colunista}/posts/${editandoId}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    setPostsColunistas(prev =>
      prev.map(post =>
        post.id_post_colunista === editandoId
          ? { ...post, ...response.data }
          : post
      )
    );

    setOpen(false);
  }

  /* =========================
     EXCLUIR POST (ADMIN)
  ========================= */
  async function excluirPost(id_post_colunista) {
    const result = await Swal.fire({
      title: "Tem certeza?",
      text: "Esse post será excluído permanentemente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#e53935",
    });

    if (!result.isConfirmed) return;

    await api.delete(
      `/admin/colunistas/${id_colunista}/posts/${id_post_colunista}`
    );

    setPostsColunistas(prev =>
      prev.filter(p => p.id_post_colunista !== id_post_colunista)
    );

    Swal.fire({
      icon: "success",
      title: "Excluído!",
      timer: 1200,
      showConfirmButton: false,
    });
  }

  /* =========================
     RENDER
  ========================= */
  return (
    <div className="container-posts">
      <div className="header-posts">
        <h2>Posts do Colunista</h2>

        <div className="containerBtn-post">
          <button className="post-inserir" onClick={abrirModal}>
            Novo post
          </button>
          <BtnVoltar voltar={voltar} />
        </div>
      </div>

      <div className="posts">
        {postsColunistas.map(post => (
          <div key={post.id_post_colunista} className="post-colunista">
            {post.foto && <img src={post.foto} alt={post.titulo} />}

            <h3>{post.titulo}</h3>

            <p>
              {post.texto.length > 120
                ? post.texto.slice(0, 120) + "..."
                : post.texto}
            </p>

            <div className="botoes-posts-colunista">
              <button onClick={() => editarPost(post)}>Editar</button>

              <button
                onClick={() =>
                  navigate(
                    `/admin/colunistas/${id_colunista}/posts/${post.id_post_colunista}`
                  )
                }
              >
                Abrir
              </button>

              <button
                onClick={() => excluirPost(post.id_post_colunista)}
              >
                Excluir
              </button>
            </div>
          </div>
        ))}
      </div>

      <Modal
        isOpen={open}
        setOpen={setOpen}
        enviar={editandoId ? enviarEdit : enviarPost}
        tipo="post"
        titulo={titulo}
        setTitulo={setTitulo}
        texto={texto}
        setTexto={setTexto}
        img={img}
        setImg={setImg}
      />
    </div>
  );
}

export default PostsColunistas;
